import Experience from "../Experience";
import Sneaker from "./Sneaker";

export default class World {

    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.resources.on('ready', () => {

            this.sneaker = new Sneaker()
            // console.log('SNEAKER', this.sneaker);

        })
    }

    update() {
        // if (this.sneaker) {
        //     this.sneaker.update()
        // }
    }

}